import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimComment.Save.IRequest;
type Response = Api.Core.ClaimComment.Save.IResponse;
type Headers = Api.Core.ClaimComment.Save.IHeaders;
const url = '/api/Claims/ClaimComment';
export default async function claimCommentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
